"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOOP_SOURCE = void 0;
exports.NOOP_SOURCE = {
    select: function () { return void 0; },
    selectAll: function () { return []; },
};
//# sourceMappingURL=noop.js.map